// Class: starling.errors.AbstractClassError

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function openfl_errors_Error() {return $import(require("openfl/errors/Error"));}

// Constructor

var AbstractClassError = function(message,id) {
	if(id == null) {
		id = 0;
	}
	if(message == null) {
		message = "Cannot instantiate abstract class";
	}
	(openfl_errors_Error().default).call(this,message,id);
}

// Meta

AbstractClassError.__name__ = ["starling","errors","AbstractClassError"];
AbstractClassError.__super__ = (openfl_errors_Error().default);
AbstractClassError.prototype = $extend((openfl_errors_Error().default).prototype, {
	
});
AbstractClassError.prototype.__class__ = AbstractClassError.prototype.constructor = $hxClasses["starling.errors.AbstractClassError"] = AbstractClassError;

// Init



// Statics




// Export

exports.default = AbstractClassError;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/errors/AbstractClassError.js
// module id = 302
// module chunks = 0